import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { IconButton, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';

import TextField from './TextField';

import { selectSearchActive, selectSearchCriteria, setSearchCriteria, submitGlobalSearch, clearSearch } from '../../../store/filtersSlice';

const SearchDiv = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
    },
    '& .MuiOutlinedInput-root': {
        paddingRight: 0,
        paddingLeft: 0,
    }
}));

export default function Search() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const searchCriteria = useSelector(selectSearchCriteria);
    const isSearchActive = useSelector(selectSearchActive);


    const handleChangeSearchCriteria = (event) => {
        const newValue = event.target.value;
        dispatch(setSearchCriteria(newValue));
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            prepareSearch();
        }
    };

    const handleSearchTap = () => {
        prepareSearch();
    };

    const clearSearchTap = () => dispatch(clearSearch());

    const prepareSearch = () => {
        dispatch(submitGlobalSearch());
        if (searchCriteria.trim() !== '') {
            navigate('/items/');
        }
    };

    return (
        <Box sx={{ display: "flex", flexGrow: 1, minWidth: 0, justifyContent: "center" }}>
            <SearchDiv>
                <TextField
                    fullWidth
                    size="small"
                    name="search"
                    placeholder={t("searchPlaceholder")}
                    id="search"
                    inputProps={{ 'aria-label': t('searchPlaceholder'), enterKeyHint: 'search' }}
                    value={searchCriteria}
                    onChange={handleChangeSearchCriteria}
                    onKeyDown={handleKeyDown}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton aria-label={t("searchContext.submit")} onClick={handleSearchTap}>
                                <SearchIcon color="primary"/>
                            </IconButton>
                        </InputAdornment>,
                        startAdornment: isSearchActive ? <InputAdornment position="start" >
                            <IconButton aria-label={t("searchContext.clear")} onClick={clearSearchTap}>
                                <CancelIcon color="primary"/>
                            </IconButton>
                        </InputAdornment> : null,
                    }}
                />
            </SearchDiv>
        </Box>
    );
}
